export type Doc360MwFn = (command: string, ...args: unknown[]) => void;

export type Doc360HostWindow = Window & {
    mw?: Doc360MwFn;
};

export function showDoc360Widget(win: Doc360HostWindow, doc: Document): void {
    if (typeof win.mw === 'function') {
        win.mw('show');
        return;
    }

    const frame = doc.getElementById('document360-widget-iframe') as HTMLIFrameElement | null;
    frame?.contentWindow?.postMessage(
        { type: 'd360:api', method: 'show', params: {} },
        '*'
    );
}

/** Public dashboards are viewable without login — the help widget must never appear there. */
export function isPublicDashboardPath(url: string): boolean {
    return /\/pages\/public-dashboard\//.test(url);
}
